export default "__VITE_ASSET__DzMrm22m__"